import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-pre-redirect-link-modal",
  templateUrl: "./pre-redirect-link-modal.component.html",
  styleUrls: ["./pre-redirect-link-modal.component.scss"],
  standalone: false,
})
export class PreRedirectLinkModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
